// Angular Files
import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule } from '@angular/core';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: 'primary' | 'accent' | 'warn';
    /** Optional third button text - if provided, shows a third button that returns 'third' */
    thirdButtonText?: string;
    /** Color for the third button (default: 'primary') */
    thirdButtonColor?: 'primary' | 'accent' | 'warn';
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    host: {
        class: 'confirm-dialog'
    },
    standalone: false
})
export class ConfirmDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
    ) {
        // Set defaults
        this.data.confirmText = this.data.confirmText || 'Confirm';
        this.data.cancelText = this.data.cancelText || 'Cancel';
        this.data.confirmColor = this.data.confirmColor || 'warn';
    }

    public onConfirm(): void {
        this.dialogRef.close(true);
    }

    public onThirdButton(): void {
        this.dialogRef.close('third');
    }
}

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule
    ],
    declarations: [ConfirmDialogComponent],
    exports: [ConfirmDialogComponent]
})
export class ConfirmDialogModule {}
